import React from "react";

import { useToolCallStore } from "@demo/store/tool-calls";

import { ToolCallEntryCard } from "./ToolCallEntryCard";

export const TOOL_CALL_SLOT_TAG = "tool-call-slot";

/** The reasoning offset a call is anchored at: where the thinking text was when it began. */
export const toolCallAnchor = (call: { reasoningAnchor: number | null }): number => call.reasoningAnchor ?? 0;

/**
 * The markup `AgentOutput` inserts into the reasoning text at a call's anchor. It is display
 * only: the annotation parser reads the raw reasoning text, and the rehype walker does not
 * count this element, so annotation ids stay aligned.
 */
export const toolCallSlotMarkup = (at: number): string =>
  `\n\n<${TOOL_CALL_SLOT_TAG} at="${at}"></${TOOL_CALL_SLOT_TAG}>\n\n`;

/** Renders the cards anchored at one reasoning offset, where those calls began in the thought stream. */
export const ToolCallSlot: React.FC<{ at: number }> = ({ at }) => {
  const order = useToolCallStore((state) => state.order);
  const calls = useToolCallStore((state) => state.calls);
  const entries = order.map((id) => calls[id]).filter((call) => call !== undefined && toolCallAnchor(call) === at);
  if (entries.length === 0) return null;

  return (
    <div className="flex w-full flex-col" data-anchor={at} data-testid="tool-call-slot">
      {entries.map((call) => (
        <ToolCallEntryCard call={call!} key={call!.id} />
      ))}
    </div>
  );
};
